import React from 'react';
import { useImageBlobUrl } from './useImageBlobUrl';
export const Image = ({ fallback, errorFallback, src, ...props }) => {
    const { blobUrl, fetching, error } = useImageBlobUrl(src);
    if (fetching) {
        return fallback;
    }
    if (error && errorFallback) {
        return errorFallback;
    }
    // eslint-disable-next-line jsx-a11y/alt-text
    return React.createElement("img", { ...props, src: blobUrl });
};
//# sourceMappingURL=Image.js.map